/**
 * The two things a person types to confirm deleting their account. The same
 * rule is enforced again by the request_account_deletion() database function,
 * so this only decides when the confirm button is enabled.
 */
export const DELETE_CONFIRMATION = "DELETE";

export function isDeletionConfirmed({
  phrase,
  email,
  accountEmail,
}: {
  phrase: string;
  email: string;
  /** The account's email; empty for accounts that have none. */
  accountEmail: string;
}) {
  if (phrase.trim() !== DELETE_CONFIRMATION) return false;
  const expected = accountEmail.trim().toLowerCase();
  return !expected || email.trim().toLowerCase() === expected;
}
